/**
 * Validates that a phone number's area code does not contain identical digits (e.g., 555, 444, 777)
 * Handles various formats: +1 (555) 123-4567, +1 555-123-4567, 555-123-4567, (555) 123-4567
 *
 * @param {string} value - The phone number to validate
 * @returns {boolean} - Returns true if valid, false if area code has identical digits
 */
export const validateAreaCode = (value) => {
    if (!value) return true;

    // Extract digits only
    let digits = value.replace(/\D/g, '');

    // If it starts with country code 1, skip it (handles +1 prefix)
    if (digits.startsWith('1') && digits.length > 10) {
        digits = digits.substring(1);
    }

    // Get the area code (first 3 digits of the remaining number)
    const areaCode = digits.substring(0, 3);

    // Check if all 3 digits are identical
    if (areaCode.length === 3 && areaCode[0] === areaCode[1] && areaCode[1] === areaCode[2]) {
        return false;
    }

    return true;
};
